import { useValidatePhoneMutation } from "@jti/store/slices/platformApiSlice";

type ValidationResult = {
  isValid: boolean;
};

export const usePhoneValidation = () => {
  const [validatePhoneMutation, validatePhoneResult] = useValidatePhoneMutation();

  const validatePhone = async (phoneNumber: string): Promise<ValidationResult> => {
    try {
      const { data: validatePhoneResponse } = await validatePhoneMutation({ phone: phoneNumber });
      const isValid = Boolean(validatePhoneResponse?.is_valid);

      return { isValid };
    } catch {
      return { isValid: false };
    }
  };

  return {
    validatePhone,
    validatePhoneResult,
  };
};
